<template>
  <v-app id="inspire">
    <Carregando v-if="!subparceirosCarregados"/>
    <v-main v-else>
      <v-container
        class="fill-height pa-0"
        fluid
        :style="`background-image: url('${backgroundImage}'); background-position: center center; background-size: cover; background-repeat: no-repeat;`"
      >
        <v-col offset-sm="1" sm="10">
          <v-row class="flex-row-reverse">
            <v-col
              sm="6"
              md="6"
              lg="4"
              xl="3"
              class="fill-height"
              align="center"
              style="background-color: #ffffff; border-radius: 12px"
            >
              <v-row align="center" class="fill-height">
                <v-col>
                  <v-avatar size="250" max-height="48px" tile>
                    <v-img :src="logoImage" height="100%" contain />
                  </v-avatar>
                  <v-row class="justify-center py-9">
                    <span class="text-login"> Selecione o parceiro</span>
                  </v-row>
                  <core-form class="mt-4" :submit="loginEmpresa">
                    <v-col class="pb-5">
                      <input-select :options="listaSubparceiros" label="Parceiro" v-model="selectedSubparceiro" return-object autofocus placeholder=" " item-value="codigo" item-text="nome" required>
                        <template v-slot:item="data">
                          <v-radio-group :value="selectedSubparceiro.codigo">
                            <v-radio
                              color="primary"
                              :label="data.item.nome"
                              :value="data.item.codigo"
                            />
                          </v-radio-group>
                        </template>
                      </input-select>
                    </v-col>
                    <v-divider />
                    <v-row class="flex-row-reverse pt-6">
                      <v-btn type="submit" class="float-left" color="primary" :disabled="!selectedSubparceiro?.codigo">
                        Continuar
                      </v-btn>
                    </v-row>
                  </core-form>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  components: {
    Carregando: () => import('./Carregando.vue')
  },
  data () {
    return {
      logoImage: '/assets/imgs/logo.svg',
      selectedSubparceiro: {},
      backgroundImage: '/assets/imgs/login-background.svg',
      subparceirosCarregados: false
    };
  },
  computed: {
    listaSubparceiros: {
      get () {
        return this.$store.state.onboarding.listaSubparceiros
      }
    }
  },
  methods: {
    loginEmpresa () {
      const empresa = JSON.parse(localStorage.getItem('empresa'))
      if (this.selectedSubparceiro?.codigo) {
        empresa.subparceiro = this.selectedSubparceiro
        localStorage.setItem('empresa', JSON.stringify(empresa))
        localStorage.setItem('isSubparceiroSelected', 'true')
        location.href = '/home'
      }
    },
    autenticarEmpresa () {
      const th = this
      th.$api.Empresa.GetByAmbiente(process.env.VUE_APP_AMBIENTE).then(response => {
        th.$api.Empresa.GetAllByCodigoPortal(response.codigoPortal).then(async (responsePortal) => {
          if (!th.$store.state.onboarding.subparceiro || !th.$store.state.onboarding.listaSubparceiros) {
            const path = `operadores-onboarding-associados/${th.$user.email}`;
            th.$api.Dbs.Get(path).then(operador => {
              localStorage.setItem('codigoOperadorDbs', operador.response.codigo);
              const parceiros = operador.response.parceiros
              const empresasFiltradas = parceiros.filter(empresaDbs =>
                responsePortal.find(empresaMultiplo =>
                  th.$api.UI.Format.SomenteNumeros(empresaDbs.documentoFederal) ===
                  th.$api.UI.Format.SomenteNumeros(empresaMultiplo.documentoFederalDBS)
                )
              );
              if (empresasFiltradas.length === 0) {
                th.$refs.loginError.openModal();
                return;
              }
              const subparceiros = empresasFiltradas[0].subparceiros || [];
              if ((['bmp', 'onboardingbmp', 'onboarding'].includes(localStorage.ambiente) || ['bmp', 'onboardingbmp', 'onboarding'].includes(process.env.VUE_APP_AMBIENTE)) && subparceiros.length > 0) {
                subparceiros.length === 1
                  ? th.$store.commit('onboarding/setSubparceiro', subparceiros[0])
                  : th.$store.commit('onboarding/setListaSubparceiros', subparceiros);
              }
            })
          }
          const dto = {
            codigoEmpresa: responsePortal[0].codigo,
            refreshToken: th.$user.refreshToken
          }
          th.$api.Autenticacao.AutenticarEmpresaOnboarding(dto).then(function (response) {
            if (th.$api.UI.PostLoadData(response, true)) {
              response.roles = th.GetUserTokenRole(response.accessToken)
              const user = th.$api.UTIL.Auth.RegisterToken(response, th.$user.identificador)
              if (user) {
                th.$store.dispatch('setUserData', { user })
                if (th.$empresa && th.$empresa.codigo !== responsePortal[0].codigo) {
                  th.$api.Empresa.GetByIdToParceiro(responsePortal[0].codigo).then(function (empresa) {
                    if (th.$api.UI.PostLoadData(empresa, true)) {
                      const empresaStorage = {
                        ...JSON.parse(localStorage.getItem('empresa')),
                        ...empresa
                      }
                      localStorage.setItem('empresa', JSON.stringify(empresaStorage))

                      const listaSubparceiros = th.$store.state.onboarding.listaSubparceiros || []
                      const subparceiroStore = th.$store.state.onboarding.subparceiro

                      const ambienteBMP = th.$aux.AmbientesOnboardingSubParceiros.includes(localStorage.ambiente) || th.$aux.AmbientesOnboardingSubParceiros.includes(process.env.VUE_APP_AMBIENTE)
                      const isSubparceiroSelected = localStorage.getItem('isSubparceiroSelected') === 'true'
                      if (ambienteBMP) {
                        if (subparceiroStore || isSubparceiroSelected || listaSubparceiros.length === 0) {
                          const empresa = JSON.parse(localStorage.getItem('empresa'))
                          empresa.subparceiro = subparceiroStore
                          localStorage.setItem('empresa', JSON.stringify(empresa))
                          localStorage.setItem('isSubparceiroSelected', 'true')
                          location.href = '/home'
                        } else {
                          localStorage.setItem('isSubparceiroSelected', 'false')
                          th.$api.UI.ShowError('Parceiro não selecionado. Selecione para continuar')
                          th.subparceirosCarregados = true
                        }
                      } else {
                        localStorage.setItem('isSubparceiroSelected', 'true')
                        location.href = '/home'
                      }
                    }
                  })
                } else {
                  localStorage.setItem('isSubparceiroSelected', 'false')
                  th.subparceirosCarregados = true
                }
              }
            } else {
              th.$refs.loginError.openModal();
            }
          })
        })
      })
    },
    GetUserTokenRole (token) {
      try {
        var base64Url = token.split('.')[1]
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        var jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split('')
            .map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            })
            .join('')
        )
        return JSON.parse(jsonPayload).client_role
      } catch {
        const jwtData = token.split('.')[1]
        const decodedJwtJsonData = window.atob(jwtData)
        return JSON.parse(decodedJwtJsonData).client_role
      }
    },
  },
  created () {
    this.autenticarEmpresa()
  }
};
</script>

<style scoped>
.text-login {
  color: #3a3939;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
</style>
